import { Key } from './Key';

export type ShortcutHandlerCallback = () => void;

export interface ShortcutHandler {
    registerOnShortcutExecutedCallback(callback: ShortcutHandlerCallback): void;
}

export class DOMShortcutHandler implements ShortcutHandler {
    private readonly keyCombo: Array<Key>;
    private readonly callbacks: Array<ShortcutHandlerCallback>;
    private readonly keyPressStatusMap: { [key: string]: boolean };

    constructor(keyCombo: Array<Key>) {
        this.keyCombo = keyCombo;
        this.keyPressStatusMap = {};
        this.callbacks = [];

        this.registerEventHandlers();
    }

    registerOnShortcutExecutedCallback(callback: () => void) {
        this.callbacks.push(callback);
    }

    private registerEventHandlers() {
        const _this = this;
        this.registerKeyDownEventHandler(_this);
        this.registerKeyUpEventHandler(_this);
    }

    private registerKeyUpEventHandler(_this: this) {
        document.addEventListener('keyup', (e) => {
            _this.trackKeyUp(e.key as Key);
        });
    }

    private registerKeyDownEventHandler(_this: this) {
        document.addEventListener('keydown', (e) => {
            _this.trackKeyDown(e.key as Key);
            _this.tryToExecuteCallbacks();
        });
    }

    private tryToExecuteCallbacks(): void {
        const canExecuteHandlers = this.allShortcutKeysArePressed();
        if (!canExecuteHandlers) { return; }
        this.executeCallbacks();
    }

    private allShortcutKeysArePressed(): boolean {
        for (const key of this.keyCombo) {
            const keyIsPressed = this.keyIsPressed(key);
            if (!keyIsPressed) { return false; }
        }
        return true;
    }

    private executeCallbacks() {
        for (const callback of this.callbacks) {
            callback();
        }
    }

    private keyIsPressed(key: Key): boolean {
        return this.keyPressStatusMap[key] === true;
    }

    private trackKeyDown(key: Key): void {
        this.keyPressStatusMap[key] = true;
    }

    private trackKeyUp(key: Key): void {
        this.keyPressStatusMap[key] = false;
    }
}



// WEBPACK FOOTER //
// ./src/webportal/utils/ShortcutHandler.ts